import React from "react";

import styled from 'styled-components';

import {
    ReportTable,
    // ReportCaption,
    ReportThead,
    ReportTbody,
    ReportTr,
    ReportTh,
    ReportTd,
} from "../../../components/OLD/Pages/Reports/CustomTable.jsx";

import Utils from "../../../utils/utils";
import { ReportUOM } from "../../../utils/enums";

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { dispatchApiCallGet, dispatchApiCallPost, dispatchApiCallPut, dispatchApiCallDelete } from '../../../../setup/redux/dispatch/actions'



const ReportTableStyle = styled(ReportTable)`
    width: 100%;

    thead {
        tr {
            border-bottom: 1px solid #DFDFDF;

            th {
                color: #7A7A7A;
                padding-bottom: 5px;
            }
        }
    }

    tbody {
        tr {
            td {
                color: #7A7A7A;
                padding-top: 3px;
                padding-bottom: 3px;
            }

            &:hover {
                td {
                    background-color: #EFF6E4;
                }
            }
        }
    }
`;


class LocalServiceHistoryForm extends React.Component {
  
    constructor(props) {
        super(props);

        let id = Utils.getIntProps(props);
        let isCopy = Utils.getBoolProps(props);
        let objectId = Utils.getIntProps(props, 'objectId');
        let objectType = Utils.getIntProps(props, 'objectType');

        this.pageName = 'customer_site_history_form';
        this.backLink = '/Customer-overview-local-services?id=' + objectId;
        
        this.state = {
            id: id,
            isCopy: isCopy,
            objectId: objectId,
            objectType: objectType,

            currentVersion: null,
            previousVersion: null,
        };
    }


    componentDidMount(){
        this.setLayoutForm();
        this.setLayoutTitle('View Changes');

        this.callDetailsApi((currentVersion, previousVersion) => {
            this.setState({
                currentVersion: currentVersion,
                previousVersion: previousVersion,
            }, () => {
                this.setLoading(false);
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        this.reduxProps(nextProps);
    }


    /* API */
    reduxProps = nextProps => {
        Utils.reduxProps(nextProps,
            this.pageName + '-details', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let currentVersion = (data && data.currentVersion) ? data.currentVersion : null;
                let previousVersion = (data && data.previousVersion) ? data.previousVersion : null;
                
                this.setState({
                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(callback){
                        callback(currentVersion, previousVersion);
                    }
                });
            }
        );
    }
	
    callDetailsApi = (callback = null) => {
        if(this.state.id){
            this.setLoading(true);
            this.props.dispatchApiCallGet(null, this.pageName + '-details', 'audittrail/compare-audit-trail/' + this.state.objectType + '/' + this.state.objectId + '/' + this.state.id, null, callback, () => {});
        } else {
            if(callback){
                callback(null, null)
            }
        }
    }
    /* END API */


    /* LAYOUT FUNCTIONS */
    setLayoutForm = (options) => {
        if(this.props.layoutRef && this.props.layoutRef.current){
            this.props.layoutRef.current.setLayoutForm(this, options);
        }
    }
    setLayoutLoading = (state = false) => {
        if(this.props.layoutRef && this.props.layoutRef.current){
            this.props.layoutRef.current.setLayoutLoading(state);
        }
    }
    setLayoutTitle = (title = '') => {
        if(this.props.layoutRef && this.props.layoutRef.current){
            this.props.layoutRef.current.setlayoutTitle(title);
        }
    }
    setLayoutSubmit = (form) => {
        if(this.props.layoutRef && this.props.layoutRef.current){
            this.props.layoutRef.current.setLayoutSubmit(form);
        }
    }
    /* END LAYOUT FUNCTIONS */


    /* FUNCTIONS */
    setLoading = (state = false) => {
        this.setLayoutLoading(state);

        if(this.props.onLoading){
            this.props.onLoading(state);
        }
    }

    setRow = (name = null, prevVal = null, currVal = null, isDiff = false) => {
        return <ReportTr>
            <ReportTd>{name ? name : '-'}</ReportTd>
            <ReportTd>{prevVal ? prevVal : '-'}</ReportTd>
            <ReportTd style={{ color: (isDiff ? '#185CFF' : '') }}>{currVal ? currVal : '-'}</ReportTd>
        </ReportTr>
    }
    /* END FUNCTIONS */


    /* FORM */
    printTableEmptyTd = () => {
        return <ReportThead>
            <ReportTr>
                <ReportTd style={{ width: '33%' }}>&nbsp;</ReportTd>
                <ReportTd style={{ width: '33%' }}>&nbsp;</ReportTd>
                <ReportTd style={{ width: '33%' }}>&nbsp;</ReportTd>
            </ReportTr>
        </ReportThead>
    }
    printTableHeader = () => {
        return <ReportThead>
            <ReportTr>
                <ReportTh style={{ width: '33%' }}>Fields</ReportTh>
                <ReportTh style={{ width: '33%' }}>Previous</ReportTh>
                <ReportTh style={{ width: '33%' }}>Current</ReportTh>
            </ReportTr>
        </ReportThead>
    }
    
    printMainTable = () => {
        return <ReportTableStyle className={"no-responsive-table"}>
            <>
                {this.printTableHeader()}
                {this.state.currentVersion && this.printMainTableBody()}
            </>
        </ReportTableStyle>
    }
    printMainTableBody = () => {
        return <ReportTbody>
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, 'Service Name', 'serviceTag')}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, '', null, () => {
                let title = 'Waste Type';
                let group = 'wasteType';
                let field = 'wasteTypeName';

                let prevItem = Utils.getPreviousValue(this.state.previousVersion, group);
                let currItem = Utils.getCurrentValue(this.state.currentVersion, group);

                let prevValue = (prevItem && prevItem[field]) ? prevItem[field] : '-';
                let currValue = (currItem && currItem[field]) ? currItem[field] : '-';
                let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);
                
                return this.setRow(title, prevValue, currValue, isDifferentValue);
            })}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, '', null, () => {
                let title = 'Bin Type';
                let group = 'binType';
                let field = 'binTypeName';

                let prevItem = Utils.getPreviousValue(this.state.previousVersion, group);
                let currItem = Utils.getCurrentValue(this.state.currentVersion, group);

                let prevValue = (prevItem && prevItem[field]) ? prevItem[field] : '-';
                let currValue = (currItem && currItem[field]) ? currItem[field] : '-';
                let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);
                
                return this.setRow(title, prevValue, currValue, isDifferentValue);
            })}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, 'Description', 'description')}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, 'Rate', 'price', () => {
                let title = 'Rate';
                let group = 'price';

                let prevItem = Utils.getPreviousValue(this.state.previousVersion, group);
                let currItem = Utils.getCurrentValue(this.state.currentVersion, group);

                let prevValue = (prevItem) ? Utils.formatNumber(prevItem) : '-';
                let currValue = (currItem) ? Utils.formatNumber(currItem) : '-';
                let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);
                
                return this.setRow(title, prevValue, currValue, isDifferentValue);
            })}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, 'Is tax inclusive', 'isTaxInclusive', () => {
                let title = 'Is tax inclusive';
                let group = 'isTaxInclusive';

                let prevItem = Utils.getCurrentPreviousBoolValue(this.state.previousVersion, group);
                let currItem = Utils.getCurrentPreviousBoolValue(this.state.currentVersion, group);

                let prevValue = (prevItem) ? prevItem : '-';
                let currValue = (currItem) ? currItem : '-';
                let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);
                
                return this.setRow(title, prevValue, currValue, isDifferentValue);
            })}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, 'Billing Action', 'billingTypeDisplay')}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, '', null, () => {
                let title = 'Billing Category';
                let group = 'chargeCategory';
                let field = 'chargeCategoryName';

                let prevItem = Utils.getPreviousValue(this.state.previousVersion, group);
                let currItem = Utils.getCurrentValue(this.state.currentVersion, group);

                let prevValue = (prevItem && prevItem[field]) ? prevItem[field] : '-';
                let currValue = (currItem && currItem[field]) ? currItem[field] : '-';
                let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);
                
                return this.setRow(title, prevValue, currValue, isDifferentValue);
            })}
            
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, 'Link To Bin Weight', 'useBinWeightQuantity', () => {
                let title = 'Link To Bin Weight';
                let group = 'useBinWeightQuantity';

                let prevItem = Utils.getCurrentPreviousBoolValue(this.state.previousVersion, group);
                let currItem = Utils.getCurrentPreviousBoolValue(this.state.currentVersion, group);

                let prevValue = (prevItem) ? prevItem : '-';
                let currValue = (currItem) ? currItem : '-';
                let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);
                
                return this.setRow(title, prevValue, currValue, isDifferentValue);
            })}
            {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, 'Non-Billable Weight To', 'nonBillableWeight', () => {
                let title = 'Non-Billable Weight To';
                let group = 'nonBillableWeight';

                let prevItem = Utils.getPreviousValue(this.state.previousVersion, group);
                let currItem = Utils.getCurrentValue(this.state.currentVersion, group);

                let prevValue = (prevItem) ? Utils.formatNumber(prevItem) : '-';
                let currValue = (currItem) ? Utils.formatNumber(currItem) : '-';
                let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);
                
                return this.setRow(title, prevValue, currValue, isDifferentValue);
            })}
        </ReportTbody>;
    }

    printBundleTable = () => {
        return (this.state.currentVersion && this.state.currentVersion.bundleServices && this.state.currentVersion.bundleServices.length > 0) && this.printBundleTableBody()
    }
    printBundleTableBody = () => {
        const id = 'serviceItemId';
        const fields = [
            {
                value: ['serviceTag'],
                title: 'Bundle Name',
            },
            {
                value: ['price'],
                title: 'Rate',
                format: (data) => {
                    return data.value ? Utils.getCurrency() + Utils.formatNumber(data.value) : data.value
                }
            },
            {
                value: ['isTaxInclusive'],
                title: 'Is tax inclusive',
                format: (data) => {
                    return data.value ? 'Yes' : 'No'
                }
            },
            {
                value: ['billingTypeDisplay'],
                title: 'Billing Action',
            },
            {
                value: ['chargeCategory', 'chargeCategoryName'],
                title: 'Billing Category',
            },
            {
                value: ['useBinWeightQuantity'],
                title: 'Link To Bin Weight',
                format: (data) => {
                    return data.value ? 'Yes' : 'No'
                }
            },
            {
                value: ['nonBillableWeight'],
                title: 'Non-Billable Weight To',
                format: (data) => {
                    return data.row.useBinWeightQuantity ? (Utils.getBillingUOM() == ReportUOM.kg) ? Utils.formatNumber(data.value, '0,0') : Utils.formatNumber(data.value, '0,0.000') : ''
                }
            }
        ];
        const arr1 = (this.state.currentVersion && this.state.currentVersion.bundleServices && this.state.currentVersion.bundleServices.length > 0) ? this.state.currentVersion.bundleServices : [];
        const arr2 = (this.state.previousVersion && this.state.previousVersion.bundleServices && this.state.previousVersion.bundleServices.length > 0) ? this.state.previousVersion.bundleServices : [];
        const differences = Utils.getDifferences(arr1, arr2, id);
        return Utils.printTable(differences, fields);
    }

    printSitesTable = () => {
        return (this.state.currentVersion && this.state.currentVersion.serviceItemCustomerSites && this.state.currentVersion.serviceItemCustomerSites.length > 0) && this.printSitesTableBody()
    }
    printSitesTableBody = () => {
        const id = 'customerSiteId';
        const fields = [
            {
                value: ['customSiteName'],
                title: 'Site Name',
            }
        ];
        const arr1 = (this.state.currentVersion && this.state.currentVersion.serviceItemCustomerSites && this.state.currentVersion.serviceItemCustomerSites.length > 0) ? this.state.currentVersion.serviceItemCustomerSites : [];
        if(arr1 && arr1.length > 0){
            for(let i = 0; i < arr1.length; i++){
                delete arr1[i].customerSite;
            }
        }
        const arr2 = (this.state.previousVersion && this.state.previousVersion.serviceItemCustomerSites && this.state.previousVersion.serviceItemCustomerSites.length > 0) ? this.state.previousVersion.serviceItemCustomerSites : [];
        if(arr2 && arr2.length > 0){
            for(let i = 0; i < arr2.length; i++){
                delete arr2[i].customerSite;
            }
        }
        const differences = Utils.getDifferences(arr1, arr2, id);
        return Utils.printTable(differences, fields);
    }
    /* END FORM */


    render() {
        return <div style={{ width: '100%' }}>
            <div>{this.printMainTable()}</div>
            <div className={'pt-10'}>{this.printBundleTable()}</div>
            <div className={'pt-10'}><b>Applicable Sites</b></div>
            <div className={'pt-4'}>
                <ReportTableStyle className={"no-responsive-table"}>
                    <>
                        <ReportThead>
                            <ReportTr>
                                <ReportTh style={{ width: '33%' }}>Fields</ReportTh>
                                <ReportTh style={{ width: '33%' }}>Previous</ReportTh>
                                <ReportTh style={{ width: '33%' }}>Current</ReportTh>
                            </ReportTr>
                        </ReportThead>
                        {Utils.getAuditTrailValue(this.state.previousVersion, this.state.currentVersion, this.setRow, '', null, () => {
                            let title = 'Is Selected All Sites';
                            let field = 'isSelectAllSites';

                            let prevValue = ((this.state.previousVersion && this.state.previousVersion[field]) ? this.state.previousVersion[field] : false).toString();
                            let currValue = ((this.state.currentVersion && this.state.currentVersion[field]) ? this.state.currentVersion[field] : false).toString();
                            let isDifferentValue = Utils.isDifferentValue(prevValue, currValue);

                            return this.setRow(title, prevValue, currValue, isDifferentValue);
                        })}
                    </>
                </ReportTableStyle>
            </div>
            <div className={'pt-4'}>{this.printSitesTable()}</div>
        </div>
    }
}

const mapDispatchToProps = {
  dispatchApiCallGet,
  dispatchApiCallPost,
  dispatchApiCallPut,
  dispatchApiCallDelete,
  clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(LocalServiceHistoryForm);
